<div *ngIf="adresse && (adresse.Name1 || adresse.AdressNummer || adresse.Strasse)">
    <div class="section">
        <div class="ion-activatable" [style.opacity]="opacity">
            <h1>{{ getEinstellung('Titel') }} <span *ngIf="nummerAnzeigen">{{ adresse.AdressNummer }}</span></h1>

            <div *ngIf="mapAnzeigen" class="map-container">
                <app-karte-widget [auftraege]="[auftrag]" [small]="true" [locationOnly]="true" [mapHeight]="mapHeight" #karteWidget></app-karte-widget>
            </div>

            <div class="adresse" appClick (clicked)="onAdresseClicked()">
                <app-adresse
                             [auftrag]="auftrag"
                             [adresse]="adresse"
                             [formularkonfiguration]="komponente"
                             (navigation)="onNavigationStarten()"
                             (anrufen)="onAnrufen()"></app-adresse>

                <div *ngIf="komponente.name === 'Abholadresse' && (auftrag.DetailInfo1 || auftrag.DetailInfo2 || auftrag.DetailInfo3)" class="info-texte-container">
                    <div class="info-texte" *ngIf="!auftrag.texteAusgeblendet">
                        <div *ngIf="auftrag.DetailInfo1" class="info1"><span>{{ auftrag.DetailInfo1 }}</span></div>
                        <div *ngIf="auftrag.DetailInfo2" class="info2"><span>{{ auftrag.DetailInfo2 }}</span></div>
                        <div *ngIf="auftrag.DetailInfo3" class="info3"><span>{{ auftrag.DetailInfo3 }}</span></div>
                    </div>

                    <ion-button fill="clear" class="button48" *ngIf="!auftrag.texteAusgeblendet" appClick (clicked)="onTexteAusblenden()">
                        <ion-icon slot="icon-only" name="eye-off"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" class="button48 btn-einblenden" *ngIf="auftrag.texteAusgeblendet" appClick (clicked)="onTexteEinblenden()">
                        <ion-icon slot="icon-only" name="eye"></ion-icon>
                    </ion-button>
                </div>
            </div>
        </div>
    </div>
</div>